import React from "react";
import styled from "styled-components";

const READINGS = styled.article`
  flex: 1;
  overflow: auto;
  overflow: auto;
  padding-bottom: 1em;
  flex: 1;
  scroll-behavior: smooth;
  .description > .title {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 32em;
    h1 {
      flex: 1;
      margin: 0;
      > a {
        color: inherit;
        text-decoration: none;
        &:hover, &:focus {
          text-decoration: underline;
        }
      }
    }
  }
  .description {
    max-width: 32em;
    position: relative;
    h1 {
      text-transform: uppercase;
      font-size: 1.75em;
      line-height: 1;
    }
    z-index: 4;
    padding: 1em;
    background: var(--main-bg-alpha);
    backdrop-filter: blur(3px);
    margin: auto;
    border-radius: 1em;
  }
`

function Readings() {
  return (
    <READINGS>
      <div class="description">
      <h1>Pessimists Aloud Podcast</h1>
        <p>
        <b>Pessimists Aloud</b> is a weekly podcast of the best Pessimists Archive articles read aloud. 
          Each episode is performed by a professional voice
          actor and has digitized records as backing music.
        </p>
      </div>
      <div>
        <iframe
          src="https://anchor.fm/pessimistsaloud/embed"
          height="90px"
          width="340px"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </READINGS>
  );
}

export default Readings;
